import { useNavigate } from "react-router-dom";

import { DesktopSlashDarkIcon } from "../../assets";
import { useAuth } from "../../useAuth";
import { getDashboardRoute } from "../../utils/routes";
import { Button, Column, Row, UserHeader } from "../../widget";

interface ErrorTemplateProps {
  errorText: string;
  errorCode: string;
}

export const ErrorTemplate = ({ errorText, errorCode }: ErrorTemplateProps): JSX.Element => {
  const navigate = useNavigate();
  const { currentUserType } = useAuth();

  return (
    <>
      <UserHeader />
      <Row spacingV="2xl" justify="center" align="center">
        <Column span={12} />
      </Row>
      <Row spacingV="ml" justify="center" align="center">
        <Column span={12}>
          <DesktopSlashDarkIcon />
        </Column>
      </Row>
      <Row spacingV="ll" justify="center" align="center">
        <Column span={12}>
          <p className="body0">OOPS!</p>
        </Column>
      </Row>
      <Row spacingV="ll" justify="center" align="center">
        <Column span={12}>
          <p className="body1">{errorText}</p>
        </Column>
      </Row>
      <Row spacingV="4xl" justify="center" align="center">
        <Column span={12}>
          <p className="body3">Error code: {errorCode}</p>
        </Column>
      </Row>
      <Row spacingV="ml" justify="center" align="center">
        <Column span={12}>
          <Button text="Go to dashboard" onClick={() => navigate(getDashboardRoute(currentUserType))} />
        </Column>
      </Row>
    </>
  );
};
